import { environmentConfig } from "@src/appV2/environment";
import { deprecatedDoNotUseLogError } from "@src/appV2/lib/analytics";

import { HttpMethod } from "../api.utils";

export enum WorkerServiceEndpoints {
  POST_REQUEST_OTP = "POST_REQUEST_OTP",
  GET_AGENT_PROFILE = "GET_AGENT_PROFILE",
  UPDATE_WORKER_PROFILE_ADDRESS = "UPDATE_WORKER_PROFILE_ADDRESS",
  POST_VERSION = "POST_VERSION",
  UPDATE_SIGNED_CONTRACTOR_AGREEMENT = "UPDATE_SIGNED_CONTRACTOR_AGREEMENT",
  POST_REQUEST_ACCOUNT_DELETION = "POST_REQUEST_ACCOUNT_DELETION",
  GET_VALIDATE_SSN_FEATURE_FLAG_VALUE = "GET_VALIDATE_SSN_FEATURE_FLAG_VALUE",
  GET_VALIDATE_DOB_FEATURE_FLAG_VALUE = "GET_VALIDATE_DOB_FEATURE_FLAG_VALUE",
  POST_ZAPIER_HOOK_FOR_DOCUMENT_REVIEW = "POST_ZAPIER_HOOK_FOR_DOCUMENT_REVIEW",
  PUT_MARK_HCP_ACTIVE = "PUT_MARK_HCP_ACTIVE",
  PUT_COMPLETE_SIGNUP = "PUT_COMPLETE_SIGNUP",
  PUT_UPDATE_AGENT = "PUT_UPDATE_AGENT",
  PUT_UPDATE_UNDER_18 = "PUT_UPDATE_UNDER_18",
  POST_PROFESSIONAL_REFERENCE = "POST_PROFESSIONAL_REFERENCE",
  GET_PROFESSIONAL_REFERENCE = "GET_PROFESSIONAL_REFERENCE",
}
export const WorkerServiceAPIMapKey = "worker_service_api_map";
export const WorkerServiceEndpointMap: {
  [key in WorkerServiceEndpoints]: { path: string; method: HttpMethod };
} = {
  [WorkerServiceEndpoints.POST_REQUEST_OTP]: {
    path: "agentProfile/v3/requestOTP",
    method: HttpMethod.POST,
  },
  [WorkerServiceEndpoints.PUT_UPDATE_AGENT]: {
    path: "onboarding/updateAgent",
    method: HttpMethod.PUT,
  },
  [WorkerServiceEndpoints.GET_AGENT_PROFILE]: {
    path: "agentProfile",
    method: HttpMethod.GET,
  },
  [WorkerServiceEndpoints.UPDATE_WORKER_PROFILE_ADDRESS]: {
    path: "agentprofile/address",
    method: HttpMethod.POST,
  },
  [WorkerServiceEndpoints.POST_VERSION]: {
    path: "agentprofile/version",
    method: HttpMethod.POST,
  },
  [WorkerServiceEndpoints.UPDATE_SIGNED_CONTRACTOR_AGREEMENT]: {
    path: "agentprofile/signContractorAgreement",
    method: HttpMethod.PATCH,
  },
  [WorkerServiceEndpoints.POST_REQUEST_ACCOUNT_DELETION]: {
    path: "agentprofile/requestAccountDeletion",
    method: HttpMethod.POST,
  },
  [WorkerServiceEndpoints.GET_VALIDATE_SSN_FEATURE_FLAG_VALUE]: {
    path: "onboarding/validateSsnFeatureFlag",
    method: HttpMethod.GET,
  },
  [WorkerServiceEndpoints.GET_VALIDATE_DOB_FEATURE_FLAG_VALUE]: {
    path: "onboarding/validateDoBFeatureFlag",
    method: HttpMethod.GET,
  },
  [WorkerServiceEndpoints.POST_ZAPIER_HOOK_FOR_DOCUMENT_REVIEW]: {
    path: "onboarding/document/fireZapierHook",
    method: HttpMethod.POST,
  },
  [WorkerServiceEndpoints.PUT_MARK_HCP_ACTIVE]: {
    path: "onboarding/operations/markActive",
    method: HttpMethod.PUT,
  },
  [WorkerServiceEndpoints.PUT_COMPLETE_SIGNUP]: {
    path: "onboarding/completeSignup",
    method: HttpMethod.PUT,
  },
  [WorkerServiceEndpoints.PUT_UPDATE_UNDER_18]: {
    path: "onboarding/updateUnder18",
    method: HttpMethod.PUT,
  },
  [WorkerServiceEndpoints.POST_PROFESSIONAL_REFERENCE]: {
    path: "references",
    method: HttpMethod.POST,
  },
  [WorkerServiceEndpoints.GET_PROFESSIONAL_REFERENCE]: {
    path: "references",
    method: HttpMethod.GET,
  },
} as const;

export const getWorkerServiceMappedURL = (endpointKey: WorkerServiceEndpoints): string => {
  const endpoint = WorkerServiceEndpointMap[endpointKey];
  try {
    const workerServiceApiMap = JSON.parse(localStorage.getItem(WorkerServiceAPIMapKey) ?? "");
    const endpointStatus = workerServiceApiMap[`${endpoint.path}_${endpoint.method}`];
    if (endpointStatus) {
      return `${environmentConfig.REACT_APP_WORKER_SERVICE_URL}/${endpoint.path}`;
    }
    return `${environmentConfig.REACT_APP_BASE_API_URL}/${endpoint.path}`;
  } catch (err) {
    deprecatedDoNotUseLogError({
      message: `getWorkerServiceMappedURL Failed while parsing ${endpointKey} - ${JSON.stringify({
        message: err.message ?? err,
        stack: err.stack ?? err,
      })}`,
    });
    return `${environmentConfig.REACT_APP_BASE_API_URL}/${endpoint.path}`;
  }
};
